import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as NeutralEmojiIcon } from 'images/stations-list/neutral-emoji.svg'
import classNames from 'classnames/bind'
import styles from './NoStationsBody.module.scss'

const cx = classNames.bind(styles)

const NoStationsBody = () => {
  const { t } = useTranslation()

  return (
    <div className={cx('no-data')} data-testid="no-data">
      <div className={cx('content')}>
        <div className={cx('emoji')}>
          <NeutralEmojiIcon />
        </div>
        <h2>{t('widgets.stationsList.noStationsFound')}</h2>
        <p>{t('widgets.stationsList.noStationsText')}</p>
      </div>
    </div>
  )
}

NoStationsBody.propTypes = {}

export { NoStationsBody }
